import Vue from "vue";
import App from "./App.vue";
import store from "./store";

// import axios (Promise based HTTP client for the browser and node.js)
import axios from "axios";
Vue.prototype.$http = axios;

// import locale (localization service)
import locale from "./services/locale.service";
Vue.prototype.$t = locale;

// import leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

Vue.config.productionTip = false;

const app = document.getElementById("m-c-map-app");
const appConfigUrl = app.getAttribute("data-app-config");
const apiFilterUrl = app.getAttribute("data-filter-url");
const apiProjectsUrl = app.getAttribute("data-projects-url");
const geoJsonUrl = app.getAttribute("data-geojson-url");

function init() {
    if (
        !app ||
        !appConfigUrl ||
        !apiFilterUrl ||
        !apiProjectsUrl ||
        !geoJsonUrl
    ) {
        console.error("Error:", "Invalid config data");
        return;
    }

    axios
        .get(appConfigUrl)
        .then((config) => {
            config.data.api = {
                FILTERS_URL: apiFilterUrl,
                PROJECTS_URL: apiProjectsUrl,
            };
            config.data.map.GEOJSON_URL = geoJsonUrl;
            store.dispatch("buildAppConfig", config.data);

            (function (el) {
                new Vue({
                    store,
                    render: (h) => h(App),
                    data: () => Object.assign({}, el.dataset),
                }).$mount("#m-c-map-app");
            })(document.getElementById("m-c-map-app"));
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Error", error.message);
            }
        });
}

init();
